<template>
  <div class="login-h5">
    <div class="login-h5-banner">
      <div class="login-h5-title">人工智能语音识别系统</div>
      <div class="login-h5-sub">移动端 · 随时随地记录</div>
    </div>

    <div class="login-h5-form">
      <el-form :rules="ruleList" :model="user" ref="userForm">
        <el-form-item prop="name">
          <el-input size="medium" class="inputOneClass" prefix-icon="el-icon-message" placeholder="请输入邮箱账号"
                    v-model="user.name" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input size="medium" class="inputOneClass" prefix-icon="el-icon-lock" v-model="user.password"
                    placeholder="请输入密码" autocomplete="new-password" show-password></el-input>
        </el-form-item>
        <el-form-item prop="validCode">
          <div style="display: flex; gap: 10px;">
            <el-input prefix-icon="el-icon-finished" v-model="user.validCode" size="medium" placeholder="请输入验证码"></el-input>
            <ValidCode @input="createValidCode" style="flex-shrink: 0;"/>
          </div>
        </el-form-item>
      </el-form>

      <el-button type="primary" size="medium" class="login-h5-btn" @click="loginClick">登 录</el-button>

      <div class="login-h5-links">
        <span @click="$router.push('/register_h5')">注册账号</span>
        <span @click="$router.push('/password_h5')">忘记密码</span>
      </div>
    </div>
  </div>
</template>

<script>
import {setRoutes} from '@/js_router/router.js'
import ValidCode from "@/vue_views/components/ValidCode";

export default {
  name: "LoginH5",
  components: {
    ValidCode: ValidCode
  },
  data() {
    return {
      user: {},
      validCode: "",
      ruleList: {
        name: [
          {required: true, message: '请输入用户名即您的邮箱', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        validCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 3, max: 4, message: '长度在3-4个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    createValidCode(data) {
      this.validCode = data
    },
    loginClick() {
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          if (!this.user.validCode) {
            this.$message.error("请填写验证码")
            return false
          }
          if (this.user.validCode.toLowerCase() !== this.validCode.toLowerCase()) {
            this.$message.error("验证码错误")
            return false
          }
          this.$http.post("/big/login", this.user).then(res => {
            if (res.data.code === "200") {
              localStorage.setItem("user", JSON.stringify(res.data.object))
              localStorage.setItem("menuList", JSON.stringify(res.data.object.menuList))
              setRoutes()
              this.$message.success("登录成功，欢迎您")
              this.$router.push("/home_h5")
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-h5 {
  min-height: 100vh;
  background: linear-gradient(160deg, #409eff 0%, #2b6fd4 45%, #f5f7fa 45%, #f5f7fa 100%);
  padding: 0 20px;
  box-sizing: border-box;
}
.login-h5-banner {
  padding: 70px 10px 50px;
  color: #fff;
}
.login-h5-title {
  font-size: 24px;
  font-weight: 700;
}
.login-h5-sub {
  margin-top: 10px;
  font-size: 14px;
  opacity: 0.85;
}
.login-h5-form {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px 30px;
  box-shadow: 0 6px 24px rgba(31, 45, 61, 0.12);
}
.login-h5-btn {
  width: 100%;
  margin-top: 6px;
  letter-spacing: 4px;
}
.login-h5-links {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  font-size: 14px;
  color: #409eff;
}
.login-h5-links span {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
</style>
